/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AppointmentAvailability } from './AppointmentAvailability';
import {
    AppointmentAvailabilityFromJSON,
    AppointmentAvailabilityFromJSONTyped,
    AppointmentAvailabilityToJSON,
    AppointmentAvailabilityToJSONTyped,
} from './AppointmentAvailability';

/**
 * 
 * @export
 * @interface CreateAppointmentRequest
 */
export interface CreateAppointmentRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentRequest
     */
    purposeKey: string;
    /**
     * 
     * @type {AppointmentAvailability}
     * @memberof CreateAppointmentRequest
     */
    availability: AppointmentAvailability;
    /**
     * 
     * @type {Date}
     * @memberof CreateAppointmentRequest
     */
    startTimeUtc: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateAppointmentRequest
     */
    endTimeUtc: Date;
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentRequest
     */
    assignedCounselorId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentRequest
     */
    clientId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAppointmentRequest
     */
    isAllDay?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentRequest
     */
    location?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentRequest
     */
    details?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentRequest
     */
    substituteCounselorId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentRequest
     */
    originTimeZoneId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAppointmentRequest
     */
    notifyBySms?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAppointmentRequest
     */
    notifyByEmail?: boolean;
}



/**
 * Check if a given object implements the CreateAppointmentRequest interface.
 */
export function instanceOfCreateAppointmentRequest(value: object): value is CreateAppointmentRequest {
    if (!('purposeKey' in value) || value['purposeKey'] === undefined) return false;
    if (!('availability' in value) || value['availability'] === undefined) return false;
    if (!('startTimeUtc' in value) || value['startTimeUtc'] === undefined) return false;
    if (!('endTimeUtc' in value) || value['endTimeUtc'] === undefined) return false;
    if (!('assignedCounselorId' in value) || value['assignedCounselorId'] === undefined) return false;
    return true;
}

export function CreateAppointmentRequestFromJSON(json: any): CreateAppointmentRequest {
    return CreateAppointmentRequestFromJSONTyped(json, false);
}

export function CreateAppointmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAppointmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'purposeKey': json['purposeKey'],
        'availability': AppointmentAvailabilityFromJSON(json['availability']),
        'startTimeUtc': (new Date(json['startTimeUtc'])),
        'endTimeUtc': (new Date(json['endTimeUtc'])),
        'assignedCounselorId': json['assignedCounselorId'],
        'clientId': json['clientId'] == null ? undefined : json['clientId'],
        'isAllDay': json['isAllDay'] == null ? undefined : json['isAllDay'],
        'location': json['location'] == null ? undefined : json['location'],
        'details': json['details'] == null ? undefined : json['details'],
        'substituteCounselorId': json['substituteCounselorId'] == null ? undefined : json['substituteCounselorId'],
        'originTimeZoneId': json['originTimeZoneId'] == null ? undefined : json['originTimeZoneId'],
        'notifyBySms': json['notifyBySms'] == null ? undefined : json['notifyBySms'],
        'notifyByEmail': json['notifyByEmail'] == null ? undefined : json['notifyByEmail'],
    };
}

export function CreateAppointmentRequestToJSON(json: any): CreateAppointmentRequest {
    return CreateAppointmentRequestToJSONTyped(json, false);
}

export function CreateAppointmentRequestToJSONTyped(value?: CreateAppointmentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'purposeKey': value['purposeKey'],
        'availability': AppointmentAvailabilityToJSON(value['availability']),
        'startTimeUtc': value['startTimeUtc'].toISOString(),
        'endTimeUtc': value['endTimeUtc'].toISOString(),
        'assignedCounselorId': value['assignedCounselorId'],
        'clientId': value['clientId'],
        'isAllDay': value['isAllDay'],
        'location': value['location'],
        'details': value['details'],
        'substituteCounselorId': value['substituteCounselorId'],
        'originTimeZoneId': value['originTimeZoneId'],
        'notifyBySms': value['notifyBySms'],
        'notifyByEmail': value['notifyByEmail'],
    };
}

